import { TrackerDataType } from '../../shared/constants/constants';
import { ContentLogKeys, EngagementKeys, IssueKeys, ServiceKeys } from '../../shared/constants/IssueAndServiceKeys';
import { CalendarTopBarView } from './CalendarCategoryBar';
import { calendarCategoryColors } from './calendarPalette';

export interface CalendarCategoryOption {
  key: CalendarTopBarView;
  label: string;
  color: string;
}

export const ALL_FIELDS_SEARCH_CATEGORY = 'All Fields';
export const SERVICE_OR_TOPIC_SEARCH_CATEGORY = 'Service/Topic';
export const CAMPAIGN_SEARCH_CATEGORY = 'Campaign';

export const calendarSearchCategoryOptions = [
  ALL_FIELDS_SEARCH_CATEGORY,
  SERVICE_OR_TOPIC_SEARCH_CATEGORY,
  CAMPAIGN_SEARCH_CATEGORY,
] as const;

export const searchCategoryByViewAndLabel: Record<CalendarTopBarView, Record<string, string>> = {
  [TrackerDataType.SERVICE]: {
    [ALL_FIELDS_SEARCH_CATEGORY]: ALL_FIELDS_SEARCH_CATEGORY,
    [SERVICE_OR_TOPIC_SEARCH_CATEGORY]: ServiceKeys.service,
    [CAMPAIGN_SEARCH_CATEGORY]: ServiceKeys.campaign,
  },
  [TrackerDataType.MEDIA_INTERACTION]: {
    [ALL_FIELDS_SEARCH_CATEGORY]: ALL_FIELDS_SEARCH_CATEGORY,
    [SERVICE_OR_TOPIC_SEARCH_CATEGORY]: IssueKeys.topic,
    [CAMPAIGN_SEARCH_CATEGORY]: IssueKeys.campaign,
  },
  [TrackerDataType.ENGAGEMENT]: {
    [ALL_FIELDS_SEARCH_CATEGORY]: ALL_FIELDS_SEARCH_CATEGORY,
    [SERVICE_OR_TOPIC_SEARCH_CATEGORY]: EngagementKeys.topic,
    [CAMPAIGN_SEARCH_CATEGORY]: EngagementKeys.campaign,
  },
  [TrackerDataType.CONTENT_LOG]: {
    [ALL_FIELDS_SEARCH_CATEGORY]: ALL_FIELDS_SEARCH_CATEGORY,
    [SERVICE_OR_TOPIC_SEARCH_CATEGORY]: ContentLogKeys.topic,
    [CAMPAIGN_SEARCH_CATEGORY]: ContentLogKeys.campaign,
  },
};

export const categoryOptions: readonly CalendarCategoryOption[] = [
  { key: TrackerDataType.SERVICE, label: 'Service Log', color: calendarCategoryColors[TrackerDataType.SERVICE] },
  {
    key: TrackerDataType.MEDIA_INTERACTION,
    label: 'Media Interactions',
    color: calendarCategoryColors[TrackerDataType.MEDIA_INTERACTION],
  },
  { key: TrackerDataType.ENGAGEMENT, label: 'Engagement Log', color: calendarCategoryColors[TrackerDataType.ENGAGEMENT] },
  { key: TrackerDataType.CONTENT_LOG, label: 'Content Log', color: calendarCategoryColors[TrackerDataType.CONTENT_LOG] },
] as const;
